import { render, staticRenderFns } from "./AccessPointStatus.vue?vue&type=template&id=4b65fbdd"
import script from "./AccessPointStatus.vue?vue&type=script&lang=js"
export * from "./AccessPointStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports